import { h } from "@stencil/core";
export class AceContentLoader {
    constructor() {
        /**
         * Whether to load the content "lazy" or not. Content which is in the first visible viewport should not be lazy loaded.
         */
        this.lazy = true;
        this.onIntersection = entries => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    /* Do not observe contentwrapper anymore */
                    if (this.observer) {
                        this.observer.disconnect();
                    }
                    this.getModel();
                }
            }
        };
    }
    componentDidLoad() {
        const loadedContentDiv = this.hostElement.querySelector('.ace-content-loader__loaded-content');
        if (loadedContentDiv) {
            if (this.lazy) {
                this.observer = new IntersectionObserver(this.onIntersection);
                this.observer.observe(loadedContentDiv);
                if (this.lazyDelay > 0) {
                    window.setTimeout(() => {
                        this.showContentLoaded(loadedContentDiv);
                    }, this.lazyDelay);
                }
                else {
                    this.showContentLoaded(loadedContentDiv);
                }
            }
            else {
                this.getModel();
            }
        }
    }
    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    showContentLoaded(loadedContentDiv) {
        loadedContentDiv.classList.remove('ace-content-loader__loaded-content--hidden');
    }
    getModel() {
        const url = this.url;
        fetch(url)
            .then(res => {
            if (res.status === 200) {
                return res.text();
            }
            else {
                this.hostElement.insertAdjacentHTML('afterend', '');
                this.hostElement.remove();
                return Promise.reject(res);
            }
        })
            .then(html => {
            this.hostElement.insertAdjacentHTML('afterend', html);
            this.hostElement.remove();
            document.dispatchEvent(new CustomEvent('contentLoaded', { detail: this.name }));
        })
            .catch(() => { });
    }
    renderLoadingSpinner() {
        return (h("div", { class: 'ace-content-loader__wrapper', tabIndex: -1 }, h("div", { class: 'ace-content-loader--loading' }, h("ace-loader", { show: true }))));
    }
    render() {
        return h("div", { key: '4cf1ad53098edb3cc8381cb99b0b667297a04419', class: 'ace-content-loader__loaded-content ace-content-loader__loaded-content--hidden' }, this.renderLoadingSpinner());
    }
    static get is() { return "ace-content-loader"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-content-loader.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-content-loader.css"]
        };
    }
    static get properties() {
        return {
            "url": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "url to fetch the content."
                },
                "getter": false,
                "setter": false,
                "attribute": "url",
                "reflect": false
            },
            "lazy": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Whether to load the content \"lazy\" or not. Content which is in the first visible viewport should not be lazy loaded."
                },
                "getter": false,
                "setter": false,
                "attribute": "lazy",
                "reflect": false,
                "defaultValue": "true"
            },
            "lazyDelay": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "lazy-delay",
                "reflect": false
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "name",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "contentLoaded",
                "name": "contentLoaded",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "hostElement"; }
}
//# sourceMappingURL=ace-content-loader.js.map
